import { h } from 'preact';
import { useState } from 'preact/hooks';
import clsx from 'clsx';
import SubMenuContainer from './submenu-container';
import voyagesTitle from '../utils/voyages-title';


const MenuItem = ({
  link,
  setShowBackDrop,
  setHeaderVoyagesLayout,
  vShowShopAllCta,
}) => {
  const [subMenuShowed, setSubMenuShowed] = useState(false);
  const isVoyagesLayout = link?.title?.includes('#voyages');
  const linkNotHash = link.url !== '#';
  const showShopAll = () => {
    if (isVoyagesLayout) {
      return linkNotHash && vShowShopAllCta;
    }
    return linkNotHash;
  };

  return (
    <li
      key={`${link.title}-${link.url}`}
      className={clsx(
        'flex items-center h-full border-b-[1.5px] border-transparent min-h-[74px]',
        isVoyagesLayout ? 'hover:border-white' : 'hover:border-black',
        link.title === 'Holiday Boutique' ? 'text-red' : '',
      )}
      onMouseEnter={() => {
        setSubMenuShowed(true);
        setShowBackDrop(true);
        setHeaderVoyagesLayout(isVoyagesLayout);
      }}
      onMouseLeave={() => {
        setSubMenuShowed(false);
        setShowBackDrop(false);
        setHeaderVoyagesLayout(false);
      }}
    >
      <a
        href={link.url}
        className={
          'utility-1 leading-[1] font-medium tracking-[0.02em] uppercase link-unstyled'
        }
      >
        {isVoyagesLayout ? voyagesTitle(link.title) : link.title}
      </a>
      {link?.submenus?.length > 0 && (
        <SubMenuContainer
          menu={link.submenus}
          subMenuShowed={subMenuShowed}
          showShopAll={showShopAll()}
          shopAllLink={link.url}
          shopAllTitle={isVoyagesLayout ? 'voyages' : link.title}
          isVoyagesLayout={isVoyagesLayout}
        />
      )}
    </li>
  );
};

export default MenuItem;
